// Converts actual HTML to the nonsense "pseudo tags"
// required by AddToCalendar
// See https://add-to-calendar-button.com/configuration#description
// @todo Add support for links if marketing needs it
const pseudoHtml = (orig: string, stripBr: boolean = true) => {
  let updated = orig;
  const simpleReplacements = ['p', 'li', 'ul', 'ol', 'li', 'strong', 'em', 'i'];

  simpleReplacements.forEach((el) => {
    updated = updated.replace(`<${el}>`, `[${el}]`)
                     .replace(`</${el}>`, `[/${el}]`);
  })

  if (stripBr) {
    updated = updated.replace(/(\r\n|\n|\r)/gm, '');
  }
  return updated;
}

export default pseudoHtml;
